import { useState, useEffect } from 'react'

/**
 * useIsTargetOffScreen
 * @param targetRef 헤더 위로 사라지는 것을 탐지할 대상의 ref
 * @returns 대상이 헤더 위로 사라지면 true를 반환합니다.
 */
const useIsTargetOffScreen = (targetRef: React.RefObject<HTMLDivElement> | null) => {
	const [isTargetOffScreen, setIsTargetOffScreen] = useState(false)
	useEffect(() => {
		if (!targetRef?.current) return undefined
		const { current: target } = targetRef
		const headerHeight = window.innerWidth < 768 ? 52 : 86
		const checkIsTargetOffScreen = () => {
			const { top } = target.getBoundingClientRect()
			const targetTop = top - headerHeight
			setIsTargetOffScreen(targetTop < 0)
		}
		checkIsTargetOffScreen()
		window.addEventListener('scroll', checkIsTargetOffScreen)
		return () => {
			window.removeEventListener('scroll', checkIsTargetOffScreen)
		}
	}, [targetRef])
	return isTargetOffScreen
}

export default useIsTargetOffScreen
